import React, { useCallback, useMemo, useState } from "react";

import TableContainer from "../../Components/Common/TableContainer";
import { Col, Row, Card, CardBody } from "reactstrap";
import Spinners from "Components/Common/Spinner";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import AddCategoryModal from "./AddCategoryModal";
import EditCategoryModal from "./EditCategoryModal"; // Import the EditCategoryModal
import { useDeleteCategory, useGetCategories } from "hooks/useCategories";
import CellActions from "Components/CellActions";

function Category() {
  document.title = "Papermap | Categories";
  const { mutate } = useDeleteCategory();

  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false); // State for Edit Modal
  const [modal1, setModal1] = useState<boolean>(false);
  const [resource, setResource] = useState<any>(null);
  const [editDetails, setEditDetails] = useState<any>(""); // State to hold edit details

  const { data, isLoading } = useGetCategories();

  const toggleViewModal = useCallback(
    (data: any) => {
      setModal1(!modal1);
      setEditDetails(data);
    },
    [modal1]
  );

  // delete resource
  const [deleteModal, setDeleteModal] = useState<boolean>(false);

  const onClickDelete = (item: any) => {
    setResource(item);
    setDeleteModal(true);
  };

  const handleDeleteOrder = () => {
    if (resource.id) {
      mutate(resource.id);
      setDeleteModal(false);
    }
  };

  const handleEditClick = (category: any) => {
    setEditDetails(category);
    setShowEditModal(true); // Open the edit modal
  };

  const columns = useMemo(
    () => [
      {
        header: "Category ID",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Description",
        accessorKey: "description",
        enableColumnFilter: false,
        enableSorting: true,
      },
      // {
      //   header: "Status",
      //   accessorKey: "id",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: (cellProps: any) => (
      //     <Badge
      //       className={
      //         "font-size-12 badge-soft-" +
      //         (cellProps.row.original.paymentStatus === "Paid"
      //           ? "success"
      //           : "danger")
      //       }
      //     >
      //       {cellProps.row.original.paymentStatus}
      //     </Badge>
      //   ),
      // },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => (
          <CellActions
            data={cellProps.row.original}
            onEdit={() => {
              setEditDetails(cellProps.row.original);
              setShowEditModal(true); // Open the edit modal
            }}
            onDelete={(categoryData) => onClickDelete(categoryData)}
          />
        ),
      },
    ],
    [handleEditClick, toggleViewModal]
  );

  return (
    <React.Fragment>
      <AddCategoryModal
        isOpen={showAddModal}
        toggle={() => setShowAddModal(!showAddModal)}
        editDetails={editDetails}
      />
      <EditCategoryModal
        isOpen={showEditModal}
        toggle={() => setShowEditModal(!showEditModal)} // Toggle the edit modal
        categoryId={editDetails.id} // Pass the ID of the category to edit
        // You can pass additional props if needed
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Categories" breadcrumbItem="Categories" />
          {isLoading ? (
            <Spinners />
          ) : (
            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <TableContainer
                      columns={columns}
                      data={data || []}
                      isGlobalFilter={true}
                      isAddButton={true}
                      isCustomPageSize={true}
                      handleUserClick={() => setShowAddModal(!showAddModal)}
                      isPagination={true}
                      SearchPlaceholder="26 records..."
                      buttonClass="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2 addOrder-modal"
                      buttonName=" Add New Category"
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                      theadClass="table-light"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
export default Category;
